import { createStore, applyMiddleware } from "redux";
import createSagaMiddleware from "redux-saga";
import RootReducers from "./RootReducers";
// import watchSagas from "./../Sagas";
import rootSaga from "./../Sagas";

const sagaMiddleware = createSagaMiddleware();

export default function ConfigureStore() {
  const store = createStore(RootReducers, applyMiddleware(sagaMiddleware));

  //--Set the store context after creating the store--//
  sagaMiddleware.setContext({
    store: store,
  });
  sagaMiddleware.run(rootSaga);

  return store;
}
